




















/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable class-methods-use-this */
import BaseComponent from '@/components/BaseComponent';
import AddLayerPanel from '@/components/layers/add-layer-panel/AddLayerPanel.vue';
import GroupLayerInfos from '@/components/layers/GroupLayerInfos.vue';
import LayerListPanel from '@/components/layers/LayerListPanel.vue';
import SingleLayerInfos from '@/components/layers/SingleLayerInfos.vue';
import LeftSideBar from '@/components/LeftSideBar.vue';
import DashBoardPanel from '@/components/map/DashBoardPanel.vue';
import FeatureInfosPanel from '@/components/map/FeatureInfosPanel.vue';
import Map from '@/components/map/Map.vue'; // @ is an alias to /src
import AlertPanel from '@/components/shared/AlertPanel.vue';
import '../plugins/bootstrap-vue';
import MapContext from '@/models/map-context/MapContext';
import Component from 'vue-class-component';
import FeatureListPanel from '@/components/layers/FeatureListPanel.vue';
import LoadingPanel from '@/components/shared/LoadingPanel.vue';
import Application from '@/models/map-context/Application';
import { EventBus, EVENTS } from '@/services/EventBus';
import Configuration from '@/models/Configuration';
import ILayer from '@/models/map-context/ILayer';
import LayerConfig from '@/models/map-context/LayerConfig';
import vSelect from 'vue-select';
import Vue from 'vue';

Vue.component('v-select', vSelect);
// eslint-disable-next-line no-use-before-define
@Component<MapWC>({
  props: {
    mapId:String,
    vue3d:Boolean
  },
  components: {
    Map,
    LeftSideBar,
    LayerListPanel,
    AddLayerPanel,
    GroupLayerInfos,
    SingleLayerInfos,
    FeatureInfosPanel,
    FeatureListPanel,
    AlertPanel,
    LoadingPanel,
    DashBoardPanel,
  },
})
export default class MapWC extends BaseComponent {
  cesiumMap = false;

  mapId!:any;

  vue3d!:boolean;

  mounted() {
    this.contextService.init(false);
    if(this.vue3d){
      this.contextService.is3d=true;
    }

    if (this.contextService.configLoaded) {
        this.onConfigLoaded(this.contextService.configuration);
    } else {
       EventBus.$on(EVENTS.CUSTOM_PLUGINS_LOADED, (config:any) => this.onConfigLoaded(config));
    }  
    
    EventBus.$on(EVENTS.SELECT_FEATURE, this.onFeatureSelected);
    
  }
  loadConfig(config:any){
    this.contextService.configuration=new Configuration(config);
    
    this.contextService.onConfigLoaded();
    EventBus.$emit(EVENTS.CONFIG_LOADED, this.contextService.configuration);


  }

  getEventBus(){
    return EventBus;
  }
  addLayerToMap(layerInfos: ILayer):LayerConfig {
    let newLayer=new LayerConfig(layerInfos);
    newLayer.visible=true;
    try {
      this.contextService.getCurrentContext().getLayers().unshift(newLayer);
      this.getMapService().addLayer(newLayer);
    } catch (error:any) {
      newLayer.addError(error);
      EventBus.$emit(EVENTS.ERROR, error);
    }
    return newLayer;
  }

  onFeatureSelected(features:any) {
    this.$emit('featureSelected',features);
  }

  destroyMap(){
    this.contextService.currentContext = null;
  }

  loadMap(context:any,application=new Application()){

    const currentAppConfig = new MapContext(JSON.parse(JSON.stringify(context)));
    this.contextService.loadContext(application, currentAppConfig);
    this.pluginService.loadPlugins(this.contextService.getCurrentContext().plugins);
  }

  loadMapById(mapId:number){

    if(mapId){
      this.contextService.currentContext = null;
      this.contextService
          .getMapById(mapId).then((reponse:any) => {
            console.log(reponse.data);
            const retour = reponse.data;
            if (retour.config !== undefined) {
              // const appConfig = JSON.parse(retour.config);
              const appConfig = retour.config;
              
              console.log('loading ', retour.config);
              const application = new Application(retour);
              this.loadMap(appConfig,application);
            }
          }).catch((error) => { EventBus.$emit(EVENTS.ERROR, error); });
    }

  }
  onConfigLoaded(config:any) {
    this.contextService.configLoaded=true;
    let mapId:any=this.mapId;

    if(mapId){
      this.contextService.currentContext = null;
      this.contextService
          .getMapById(parseInt(mapId, 10)).then((reponse:any) => {
            console.log(reponse.data);
            const retour = reponse.data;
            if (retour.config !== undefined) {
              // const appConfig = JSON.parse(retour.config);
              const appConfig = retour.config;
              
              console.log('loading ', retour.config);
              const application = new Application(retour);
              this.loadMap(appConfig,application);
            }
          }).catch((error) => { EventBus.$emit(EVENTS.ERROR, error); });
    }

      
  }

  get isMapContextLoaded() {
    console.log('isMapContextLoaded', this.contextService.currentContext !== null);
    return this.contextService.currentContext !== null;
  }
}
